<template>
  <div>
    <!--头部-->
    <HeaderForBeauty :showValue="5"></HeaderForBeauty>
    <div class="jqgk">
   <div class="contai" style="max-width: 1197px;background:white;padding-left:40px;padding-right:40px;margin-bottom: 40px">
        <div class="top_tit" style="margin-top: 20px">
          <div style="text-align:left;font-size:16px;height:40px;line-height:40px;font-weight:600;color:black;padding-top:5px">电子书籍</div>

          <div style="height: 1px; width: 100%"></div>
          <div style="text-align: left; margin: 0px">
            <div class="travel_con">
              <div class="">
                <!-- 图片显示 -->
                <el-row  style="margin-right: 0px; margin-top: 10px">
                  <div v-for="item in dataList" :key="item.id">
                    <el-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
                      <a>
                        <div

                          class="showPicture"
                          @click="next(item.id)"
                        >
                          <img
                            :src="item.cover"
                            alt="...."
                            class="sceneryImgSize"
                          />
                          <div class="new-sceneryFontSize">{{ item.title }}</div>

                        </div>
                      </a>
                    </el-col>
                  </div>
                  </el-row>

            </div>
          </div>
        </div>
      </div>
           </div>

    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import { getBeautyForSJ } from '@/api/public'
import HeaderForBeauty from './headerforbeauty'
import Footer from './footer'
export default {
  components: { HeaderForBeauty, Footer },
  data () {
    return {
      dataList: []
    }
  },
  beforeCreate () {},
  created () {
    // if (this._isMobile()) {
    //   this.pcshow = false;
    // } else {
    //   this.pcshow = true;
    // }
  },

  mounted () {
    this.initList()
  },

  methods: {
    next (id) {
      this.ids = id
      // window.open('http://127.0.0.1:8848/TurnBook/index.html?'+ this.ids)
      // window.open('http://39.99.34.16:9200?'+ this.ids)
      window.open('http://www.xiqiaoshantour.com/dzs?' + this.ids)
    },
    openUrl (url) {
      window.open(url)
    },
    // 属性排序sort
    compare (property) {
      return function (a, b) {
        var value1 = a[property]
        var value2 = b[property]
        return value1 - value2
      }
    },
    initList () {
      var that = this
      getBeautyForSJ().then(response => {
        var list = response.data
        console.log('that.dataList111:', list)
        var listCopy = []
        // this.dataList = response.data
        for (let index = 0; index < list.length; index++) {
          if (list[index].title === '电子书籍' && list[index].hideIs === 1) {
            listCopy = []
            that.dataList = []
            window.open(list[index].url)
            break
          } else {
            if (list[index].hideIs === 1) {
              listCopy = listCopy.concat(list[index])
            }
          }
          that.dataList = listCopy
        }
        console.log('that.dataList222:', that.dataList)
      })
    }
  }
}
</script>

<style>
.showPicture {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  margin: 0 10px 30px 0;
}
.sceneryImgSize {
  height: 200px;
}
.new-sceneryFontSize {
  font-size: 14px;
  font-family: "Source Han Sans CN";
  font-weight: bold;
  color: black;
  width: 270px;
  /* height: 40px;
  line-height: 40px; */
  padding: 8px 20px;
  overflow-x: hidden;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/BeautyAllOverForBook.vue